import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const AUTHENTICATION_SIDENAV_LINKS = new InjectionToken<void>("AUTHENTICATION_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "Authentication",
        icon: "key",
        label: "SETTINGS.ITEMS.AUTHENTICATION",
        expanded: true,
        items: [
          {
            id: "Permission-Groups",
            label: "SETTINGS.ITEMS.PERMISSION_GROUPS",
            routerLink: "/settings/permission-groups",
            permissions: COMMON_GUARD_OPTIONS.PERMISSION_GROUP.VIEW.permissions,
          },
          {
            id: "Roles",
            label: "SETTINGS.ITEMS.ROLES",
            routerLink: "/settings/roles",
            permissions: COMMON_GUARD_OPTIONS.ROLE.VIEW.permissions,
          },
          {
            id: "UsersWithCredentials",
            label: "SETTINGS.ITEMS.USERS_WITH_CREDENTIALS",
            routerLink: "/settings/users",
            permissions: COMMON_GUARD_OPTIONS.USER.VIEW.permissions,
          },
          {
            id: "AuditLogs",
            label: "SETTINGS.ITEMS.AUDIT_LOGS",
            routerLink: "/settings/audit-logs",
            permissions: COMMON_GUARD_OPTIONS.AUDIT_LOG.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
